<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="blanApply" :areaShow="areaShow" :loginShow="loginShow" :get-party-id="getPartyId" :reload-page="reloadPage"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <a href="javascript:void(0)" @click="urlTo('applyIndex')">个人办事</a> / <a href="javascript:void(0)" @click="urlTo('guideIndex',{service_code:archive_type_code,nav_name:nav_name})">办事指南</a> / <span>{{nav_name}}申请</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <!--申报信息 -->
          <div v-show="stepFlag=='apply'" class="deal">
            <h2 class="tit8 line_bottom"><span><img src="../../../static/images/guide_sign7.png"> 选择办理方式</span><em></em></h2>
            <dl class="safe_appply" >
              <dd><span class="title"> 区划：</span><em><el-cascader  ref="cs2"  v-model="selectedRegion" :props="props" placeholder="请选择区划" style="width: 80%;margin-right: 5px;" ></el-cascader><img src="../../../static/images/required.png"></em></dd>
              <dd><span class="title"> 办事单位：</span><em><el-cascader :options="departOption" v-model="selecteddepartOption" clearable  placeholder="请选择办事单位"  style="width: 80%;margin-right: 5px;"  ></el-cascader><img src="../../../static/images/required.png"></em></dd>
              <dd><span class="title"> 办理方式：</span><em>
                <el-select v-model="blanApply.baseInfo.apply_way" placeholder="请选择" @change="selectApplyType"  style="width: 80%;margin-right: 5px;" >
                <el-option
                  v-for="item in way_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select><img src="../../../static/images/required.png"></em></dd>
              <dd style="height: 120px;"  v-if="blanApply.baseInfo.apply_way==1"><span class="title"> &nbsp; &nbsp;</span>
                <em style="display: flex;justify-content: left;">
                  <div style="width: 190px;margin-right: 10px;">
                <el-upload
                  class="avatar-uploader"
                  list-type="picture"
                  action=""
                  :file-list="frontFileList"
                  :show-file-list="false"
                  :http-request="afterReadOne"
                  :on-remove="handleRemove"
                >
                  <img v-if="idcard_pic_front_img" :src="idcard_pic_front_img" class="avatar" style="width:180px;height: 127px;">
                  <img  v-else src="../../../static/images/id_front.png" style="width: 180px;height: 127px;">
                </el-upload>
                  </div>
                  <div style="width: 190px;">
                  <el-upload
                    class="avatar-uploader"
                    list-type="picture"
                    action=""
                    :file-list="backFileList"
                    :show-file-list="false"
                    :http-request="afterReadTwo"
                    :on-remove="handleRemove"
                  >
                    <img v-if="idcard_pic_back_img" :src="idcard_pic_back_img" class="avatar" style="width:180px;height: 127px;">
                    <img v-else src="../../../static/images/id_back.png" style="width: 180px;height: 127px;">
                  </el-upload>
                  </div>
                </em>
              </dd>
              <dd v-if="isShow"><span class="title"> 申请人姓名：</span><em>

                <el-input v-if="1==person_uid_disable" readonly="readonly" v-model="blanApply.baseInfo.person_name" placeholder="请输入申请人姓名"  style="width: 80%;margin-right: 5px;"></el-input>
                <el-input v-else v-model="blanApply.baseInfo.person_name" placeholder="请输入申请人姓名"  style="width: 80%;margin-right: 5px;"></el-input>

                <img src="../../../static/images/required.png"></em> </dd>
              <dd v-if="isShow"><span class="title"> 申请人身份证：</span><em>

                <el-input v-if="1==person_uid_disable" readonly="readonly" v-model="blanApply.baseInfo.person_uid" maxlength="18" placeholder="请输入身份证号" style="width: 80%;margin-right: 5px;"></el-input>
                <el-input v-else v-model="blanApply.baseInfo.person_uid" maxlength="18" placeholder="请输入身份证号" style="width: 80%;margin-right: 5px;"></el-input>

                <img src="../../../static/images/required.png"></em> </dd>


              <dd v-if="isShow"><span class="title"> 紧急联系人姓名：</span><em><el-input v-model="blanApply.baseInfo.emergency_name" maxlength="11" placeholder="请输入紧急联系人姓名"  style="width: 80%;margin-right: 5px;"></el-input><img src="../../../static/images/required.png"></em> </dd>
              <dd v-if="isShow"><span class="title"> 紧急联系人电话：</span><em><el-input v-model="blanApply.baseInfo.emergency_mobile" maxlength="11" placeholder="请输入紧急联系人电话"  style="width: 80%;margin-right: 5px;"></el-input><img src="../../../static/images/required.png"></em> </dd>
              <dd v-if="isShow"><span class="title"> 紧急联系人与申请人关系：</span><em>
                <el-select
                  v-model="blanApply.baseInfo.emergency_relation_id"
                  collapse-tags
                  placeholder="请选择" style="width: 80%;margin-right: 5px;">
                  <el-option
                    v-for="item in relation"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id" v-if="item.name !='无'">
                  </el-option>
                </el-select>
                <img src="../../../static/images/required.png"></em> </dd>

              <dd v-if="isShow"><span class="title"> 在享待遇： </span><em><el-input v-model="enjoy_treat" readonly="" placeholder="在享待遇" style="width: 80%;margin-right: 5px;color: red"></el-input></em> </dd>
              <dd v-if="isShow"><span class="title"> 申请原因： </span><em>
               <el-input
                  type="textarea" maxlength="200"
                  :rows="3"
                  placeholder="请输入申请原因"
                  v-model="blanApply.baseInfo.req_reason" style="width: 80%;margin-right: 5px;">
                </el-input><img src="../../../static/images/required.png"></em></dd>
              <dd v-if="qxAlertFlag" style="margin-top: 0px;"><span class="title">&nbsp; </span><em style="line-height: 30px;"><div v-if="qxAlertFlag" style="width:80%;line-height: 30px;" class="alert_f_css">
                <el-alert
                  :closable="false"
                  :title="alertMsg"
                  :type="alertType"
                  show-icon>
                </el-alert>
              </div></em></dd>
              <dd style="text-align: center;padding-top: 20px;">
                <el-button type="primary"  @click="applyNextStep" style="padding-left:30px;padding-right: 25px;">下一步</el-button>
              </dd>
            </dl>
          </div>


          <div v-show="stepFlag !='apply'"  class="advice">
            <h2 class="tit8 line_bottom"><span><img src="../../../static/images/guide_sign12.png">{{title_info}}</span><em><img src="../../../static/images/required.png"> 为必填项</em></h2>
            <div class="advance_infor" style="padding-top: 5px;">
              <div style="width: 80%;margin: 0 auto;">
              <el-steps :active="stepactive" finish-status="success" simple style="margin-top: 20px">
              <el-step title="基本信息" ></el-step>
              <el-step title="上传资料" ></el-step>
              <el-step title="完成" ></el-step>
            </el-steps></div></div>
             <!--申请人信息begin-->

            <el-form  :rules="reqManInfo_rules" :model="blanApply.reqManInfo" label-width="140px" ref="reqManInfo_ruleForm" class="demo-ruleForm">
            <table v-show="stepFlag=='reqManInfo'" width="80%" border="0" cellspacing="0" cellpadding="0" class="advice_tab_new22" style="padding-top:15px;margin: 0 auto;">
              <tr>
                <td colspan="3"><h2 class="information_tit">基本信息</h2></td>
              </tr>
              <tr>
                <td width="45%">
                  <el-form-item  label="姓 名：" prop="person_name">
                  <el-input v-model="blanApply.reqManInfo.person_name" placeholder="请输入申请人姓名" :readonly="true"  style="width: 250px;" ></el-input>
                  </el-form-item>
                </td>
                <td width="4%">&nbsp;</td>
                <td width="40%">
                  <el-form-item  label="身份证号：" prop="person_uid">
                  <el-input v-model="blanApply.reqManInfo.person_uid" placeholder="请输入身份证号" :readonly="true"  style="width: 250px;"></el-input>
                  </el-form-item>
                </td>

              </tr>
              <tr>
                <td >
                  <el-form-item  label="性 别：" prop="person_sex">
                  <el-select
                    v-model="blanApply.reqManInfo.person_sex"
                    collapse-tags :disabled="true"
                    placeholder="请选择" style="width: 250px;">
                    <el-option
                       label="男"
                       value="1">
                    </el-option>
                    <el-option
                       label="女"
                       value="0">
                    </el-option>
                  </el-select>
                  </el-form-item>
                </td>
                <td>&nbsp;</td>
                <td>
                  <el-form-item  label="出生日期：" prop="person_birthday">
                  <el-date-picker :disabled="true"
                  v-model="blanApply.reqManInfo.person_birthday"
                  type="date"
                  placeholder="选择日期" style="width: 250px;">
                </el-date-picker>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item  label="年 龄：" prop="person_age">
                  <el-input v-model="blanApply.reqManInfo.person_age" placeholder="请输入年龄"  style="width: 250px;"></el-input>
                  </el-form-item>
                </td>
                <td>&nbsp;</td>
                <td>
                  <el-form-item  label="民 族：" prop="nations_type_id">
                  <el-select
                  v-model="blanApply.reqManInfo.nations_type_id"
                  collapse-tags
                  placeholder="请选择" style="width: 250px;">
                  <el-option
                    v-for="item in nations_type"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item  label="户籍地址：" prop="regi_address">
                  <el-input v-model="blanApply.reqManInfo.regi_address" placeholder="请输入户籍地址"  style="width: 250px;"></el-input>
                  </el-form-item>
                </td>
                <td>&nbsp;</td>
                <td>
                  <el-form-item  label="居住地址：" prop="living_address">
                  <el-input v-model="blanApply.reqManInfo.living_address" placeholder="请输入居住地址"  style="width: 250px;"></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td><el-form-item  label="联系电话：" prop="mobile">
                  <el-input v-model="blanApply.reqManInfo.mobile" @change="mobileChange" maxlength="11" placeholder="请输入联系电话"  style="width: 250px;"></el-input>
                </el-form-item></td>
                <td>&nbsp;</td>
                <td>
                  <!--<el-form-item  label="户口性质：" prop="regi_kind">-->
                    <!--<el-select-->
                      <!--v-model="blanApply.reqManInfo.regi_kind"-->
                      <!--collapse-tags-->
                      <!--placeholder="请选择" style="width: 250px;">-->
                      <!--<el-option-->
                        <!--v-for="item in regi_kind"-->
                        <!--:key="item.id"-->
                        <!--:label="item.name"-->
                        <!--:value="item.id">-->
                      <!--</el-option>-->
                    <!--</el-select>-->
                  <!--</el-form-item>-->
                  <el-form-item  label="户口类型：" prop="city_is">
                    <el-select
                      v-model="blanApply.reqManInfo.city_is"
                      collapse-tags
                      placeholder="请选择" style="width: 250px;">
                      <el-option
                        v-for="item in city_is"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item  label="是否低保：" prop="is_blan">
                    <el-select
                      v-model="blanApply.reqManInfo.is_blan"
                      collapse-tags @change="isBlanChange"
                      placeholder="请选择" style="width: 250px;">
                      <el-option
                        v-for="item in is_blan_type"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <td>&nbsp;</td>
                <td>
                  <el-form-item  label="低保类别："  prop="blan_type">
                    <el-select
                      v-model="blanApply.reqManInfo.blan_type"
                      collapse-tags :disabled="blanApply.reqManInfo.is_blan!=1"
                      placeholder="请选择" style="width: 250px;">
                      <el-option
                        v-for="item in blan_type"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item  label="社会保障号："  prop="soical_ins_number">
                    <el-input v-model="blanApply.reqManInfo.soical_ins_number" placeholder="请输入社会保障号"  style="width: 250px;"></el-input>
                  </el-form-item>
                </td>
                <td>&nbsp;</td>
                <td><el-form-item  label="是否有监护人：" prop="is_blan">
                  <el-select
                    v-model="blanApply.reqManInfo.is_guardian_person"
                    collapse-tags
                    placeholder="请选择" style="width: 250px;">
                    <el-option
                      v-for="item in is_guardian_person_type"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item></td>
              </tr>
              <tr >
                <td colspan="2"><h2 class="information_tit">健康信息</h2></td>
                <td ><div style="width:390px;text-align: right"><el-button type="primary" icon="el-icon-circle-plus-outline" v-if="addCan && canEditBoolean" @click="addDisCol">添加残疾信息</el-button><el-button  icon="el-icon-remove-outline"  v-if="delCan && canEditBoolean" @click="delDisCol">删除残疾信息</el-button></div></td>
              </tr>
              <tr>
                <td>
                  <el-form-item  label="自理能力：" prop="viability_id">
                    <el-select
                      v-model="blanApply.reqManInfo.viability_id"
                      collapse-tags
                      placeholder="请选择" style="width: 250px;">
                      <el-option
                        v-for="item in viability"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>

                </td>
                <td>&nbsp;</td>
                <td>
                  <el-form-item  label="残疾证号：" prop="disability_number">
                    <el-input v-model="blanApply.reqManInfo.disability_number" maxlength="20" @change="disabilityChange" placeholder="请输入残疾证号" style="width: 250px;" ></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr v-for="(items,index) in blanApply.reqManInfo.dis_info">
                <td>
                  <el-form-item  :label="getDisTypeLabel('残疾类型',index,blanApply.reqManInfo.dis_info.length)" :prop="'dis_info.' + index + '.dt_id'" :rules="[{ required: true, message: '请选择残疾类型',trigger: 'change'}]">
                    <el-select :disabled="disCan"
                      v-model="items.dt_id"
                      collapse-tags
                      placeholder="请选择" style="width: 250px;">
                      <el-option
                        v-for="item in dis_type"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>

                </td>
                <td>&nbsp;</td>
                <td >
                  <el-form-item  :label="getDisLevelLabel('残疾等级',index,blanApply.reqManInfo.dis_info.length)" :prop="'dis_info.' + index + '.dl_id'" :rules="[{ required: true, message: '请选择残疾等级',trigger: 'change'}]">
                    <el-select
                      v-model="items.dl_id"
                      collapse-tags :disabled="disCan"

                      placeholder="请选择" style="width: 250px;">
                      <el-option
                        v-for="item in dis_level"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td colspan="3"><h2 class="information_tit">银行信息</h2></td>
              </tr>

              <tr>
                <td>
                  <el-form-item  label="银行类型：" prop="bank_type_id">
                  <el-select
                  v-model="blanApply.reqManInfo.bank_type_id"
                  collapse-tags @change="selectBankType"
                  placeholder="请选择" style="width: 250px;">
                  <el-option
                    v-for="item in bank_type"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
                  </el-form-item>
                </td>
                <td>&nbsp;</td>
                <td>
                  <el-form-item  label="银行卡类型：" prop="bank_card_type">
                    <el-select
                      v-model="blanApply.reqManInfo.bank_card_type"
                      collapse-tags
                      placeholder="请选择" style="width: 250px;">
                      <el-option
                        v-for="item in bank_card_type"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id" v-if="item.name !='无'">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item  label="开户证件类型：" prop="open_document_type">
                    <el-select
                      v-model="blanApply.reqManInfo.open_document_type"
                      collapse-tags
                      placeholder="请选择" style="width: 250px;">
                      <el-option
                        v-for="item in open_document_type"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id" v-if="item.name !='无'">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <td>&nbsp;</td>
                <td>
                  <el-form-item  label="银行卡号：" prop="bank_account_code">
                    <el-input v-model="blanApply.reqManInfo.bank_account_code" placeholder="请输入银行卡号" maxlength="21"  style="width: 250px;"></el-input>
                  </el-form-item>
                  <el-input v-model="blanApply.reqManInfo.bank_name" placeholder="请输入银行名称"   style="width: 250px;display: none"></el-input>
                </td>
            </tr>
              <tr>
                <td>
                  <el-form-item  label="银行户名：" prop="bank_account_name">
                    <el-input v-model="blanApply.reqManInfo.bank_account_name" @change="bankPersonNameChange" placeholder="请输入银行户名"  style="width: 250px;"></el-input>
                  </el-form-item>
                </td>
                <td>&nbsp;</td>
                <td>
                  <el-form-item  label="开户身份证号：" prop="bank_person_uid">
                    <el-input v-model="blanApply.reqManInfo.bank_person_uid"  @change="bankPersonUidChange"  maxlength="18"   placeholder="请输入开户身份证号"  style="width: 250px;"></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>

                <td>
                  <el-form-item  label="与申请人关系：" prop="bank_relation_id">
                    <el-select
                      v-model="blanApply.reqManInfo.bank_relation_id"
                      collapse-tags @change="bankRelationChange"
                      placeholder="请选择" style="width: 250px;">
                      <el-option
                        v-for="item in relation"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id" v-if="item.name !='无'">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <td>&nbsp;</td>
                <td></td>
              </tr>

              <tr v-if="blanApply.reqManInfo.is_guardian_person==1">
                <td colspan="3"><h2 class="information_tit">监护人信息</h2></td>
              </tr>
              <tr v-if="blanApply.reqManInfo.is_guardian_person==1 && blanApply.reqManInfo.guardian_reqman_relation_name && blanApply.reqManInfo.guardian_reqman_relation_name!='本人' && blanApply.reqManInfo.guardian_reqman_relation_name!='户主'">
                <td colspan="3" >
                  <div style="display: flex;justify-content: center;width: 100%;margin-bottom: 5px;">
                  <div style="width: 190px;margin-right: 10px;">
                    <el-upload
                      class="avatar-uploader"
                      list-type="picture"
                      action=""
                      :file-list="fmfrontFileList"
                      :show-file-list="false"
                      :http-request="afterReadOne_m"
                      :on-remove="handleRemove"
                      :disabled="!canEditBoolean"
                    >
                      <img v-if="idcard_pic_front_img_jf" :src="idcard_pic_front_img_jf" class="avatar" style="width:180px;height: 127px;">
                      <img  v-else src="../../../static/images/id_front.png" style="width: 180px;height: 127px;">
                    </el-upload>
                  </div>
                  <div style="width: 190px;">
                    <el-upload
                      class="avatar-uploader"
                      list-type="picture"
                      action=""
                      :file-list="fmbackFileList"
                      :show-file-list="false"
                      :http-request="afterReadTwo_m"
                      :on-remove="handleRemove"
                      :disabled="!canEditBoolean"
                    >
                      <img v-if="idcard_pic_back_img_jf" :src="idcard_pic_back_img_jf" class="avatar" style="width:180px;height: 127px;">
                      <img v-else src="../../../static/images/id_back.png" style="width: 180px;height: 127px;">
                    </el-upload>
                  </div>
                  </div>
                  <div v-if="qxAlertFlag" style="width:400px;margin: 0 auto;line-height: 30px;margin-bottom: 5px;">
                    <el-alert
                      :closable="false"
                      :title="alertMsg"
                      :type="alertType"
                      show-icon>
                    </el-alert>
                  </div>
                </td>
              </tr>
              <tr v-if="blanApply.reqManInfo.is_guardian_person==1">
                <td><el-form-item  label="与申请人关系：" prop="guardian_reqman_relation_id">
                  <el-select
                    v-model="blanApply.reqManInfo.guardian_reqman_relation_id"
                    collapse-tags @change="relationChange"
                    placeholder="请选择" style="width: 250px;">
                    <el-option
                      v-for="item in relation"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id" v-if="item.name !='无'">
                    </el-option>
                  </el-select>
                </el-form-item></td>
                <td></td>
                <td>
                  <el-form-item  label="监护人姓名：" prop="guardian_person_name">
                    <el-input v-model="blanApply.reqManInfo.guardian_person_name" placeholder="请输入监护人姓名"  style="width: 250px;"></el-input>
                  </el-form-item>
                </td>
              </tr>

              <tr v-if="blanApply.reqManInfo.is_guardian_person==1">

                <td>
                  <el-form-item  label="监护人身份证：" prop="guardian_person_uid">
                    <el-input v-model="blanApply.reqManInfo.guardian_person_uid"  maxlength="18" placeholder="请输入监护人身份证"  style="width: 250px;"></el-input>
                  </el-form-item>
                </td><td>&nbsp;</td>
                <td>
                  <el-form-item  label="监护人联系电话：" prop="guardian_phone">
                    <el-input v-model="blanApply.reqManInfo.guardian_phone" maxlength="11" @change="guardianPhoneChange" placeholder="请输入监护人联系电话"  style="width: 250px;"></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td colspan="3"  style="height: 50px;line-height: 50px;text-align: center;padding-top: 10px;">
                  <el-button type="primary"  @click="upStep('apply',0,'提交基本信息')" style="padding-left:30px;padding-right: 25px;">上一步</el-button>
                  <el-button  type="primary"  @click="infoNext('materialinfo',1,'上传资料')" style="padding-left:30px;padding-right: 25px;">下一步</el-button>
                </td>
              </tr>
            </table>
            </el-form>
            <!--附加上传begin--->
            <table v-show="stepFlag=='materialinfo'" width="90%" border="0" cellspacing="0" cellpadding="0" class="advice_tab" style="padding-top:15px;">
              <tr  v-for="(photo,index) in photos"  :key="index">
                <td width="15%" align="right" style="padding-left: 6%;">{{photo.name}}：</td>
                <td  style="padding-left: 10px;padding-top: 5px;padding-bottom: 5px;">

                  <imgUploader :file-type="photo.type" :limit="photo.limit" :canEdit="canEditBoolean" v-model="photo.photos"/>

                </td>
              </tr>
              <tr>
                <td colspan="3"   style="height: 50px;line-height: 50px;text-align: center;padding-top: 10px;">
                  <el-button   @click="upStep('reqManInfo',0,'提交基本信息')" style="padding-left:30px;padding-right: 25px;">上一步</el-button>
                  <el-button  type="primary"  @click="onSave" style="padding-left:30px;padding-right: 25px;" v-if="canEditBoolean">保存</el-button>
                  <el-button  type="primary"  @click="onSubmit" style="padding-left:30px;padding-right: 25px;" v-if="canEditBoolean">提交</el-button>
                </td>
              </tr>
            </table>
            <!--附加上传end--->
          </div>

        </div>
      </div>
    </div>

    <el-dialog
      title="实名认证提示"
      :visible.sync="smDialogShow"
      width="400px"
      :before-close="handleClose">
      <span>根据政策规定，在线申办业务，需要实名认证！请选择：<br />1、点击【确定】跳转到实名认证页面<br />2、点击【取消】返回上一级页面</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="sureClose">确 定</el-button>
  </span>
    </el-dialog>

    <div class="clear"></div>
    <footers></footers>

  </div>
</template>
<script>
import headers from "../../components/Headers";
import fixedDiv from "../../components/FixedDiv";
import footers from "../../components/Footer";
import imgUploader from "../../components/ImgUploader";
export default {
  inject:['reload'],
  name: "public-index",
  components:{
    headers,fixedDiv,footers,imgUploader
  },
  data() {
    let _self=this;
    return {
      upImgOk:1,
      //身份证输入框是否禁用，1禁用
      person_uid_disable:1,

      is_submit:false,
      title_info:'',
      familyUserDialog:false,
      stepFlag:'apply',//apply申请也 familyInfo家庭页,master申请人
      stepactive:0,
      qxAlertFlag:false,
      alertMsg:'',
      alertType:'',
      smDialogShow:false,
      width:document.body.clientWidth+'px',
      height:document.body.clientHeight+'px',
      apply_id:'',
      party_id:'',
      nav_name:'',
      nav_name_apply:'',
      service_code:'',
      dataObjList:[],
      areaShow:false,
      loginShow:false,
      canEditBoolean:true,
      reloadFlag:false,
      selectedRegion:[],
      selecteddepartOption:[],
      departOption:[],
      enjoy_treat:'无',
      props: {
        lazy: true,
        checkStrictly:true,
        lazyLoad (node, resolve) {
          const { level } = node;
          if(!node.value){
            node.value=_self.$cookies.get("areaRoot");
          }
          const options={pid:node.value}
          _self.$https.post("api/pu/getAreaByParentCode.do",options,response=>{
            const nodes =[];
            if (response.status === 200 && response.data.code===200) {
              const nodes =Object.values(response.data.data).map(function(e){
                return {label:e.name,value:e.code,level:0, leaf: level >= 2}
              })
              resolve(nodes);
            } else {
              resolve(nodes);
            }

          })
        }
      },
      way_options:[
        {
        value:0,
        label:'本人办理'
        },{
          value:1,
          label:'委托办理'
        }
      ],
      reqManInfo_rules:{
        city_is:[ {required: true, message: '户口类型不能为空', trigger: 'change' }],
        bank_card_type:[{required:true,message:'请选择银行卡类型',tigger:'change'}],
        open_document_type:[{required:true,message:'请选择银行开户证件类型',tigger:'change'}],
        person_name:[{required:true,message:'请输入申请人姓名',tigger:'blur'}],
        person_uid:[{required:true,validator:this.checkUid,tigger:'blur'}],
        person_sex:[{required:true,message:'请选择性别',tigger:'change'}],
        person_birthday:[{required:true,message:'请选择出生日期',tigger:'blur'}],
        person_age:[{required:true,message:'请输入年龄',tigger:'blur'},
          {required:true,pattern:/^(([0-9]|[1-9][0-9]|1[0-7][0-9])(\\.[0-9]+)?|180)$/,message:'请输入正确的年龄',tigger:'blur'}],
        nations_type_id:[{required:true,message:'请选择民族',tigger:'change'}],
        regi_kind:[{required:true,message:'请选择户口性质',tigger:'change'}],
        regi_address:[{required:true,message:'请输入户籍地址',tigger:'blur'}],
        living_address:[{required:true,message:'请输入居住地址',tigger:'blur'}],
        dt_id:[{required:true,message:'请选择残疾类型',tigger:'change'}],
        dl_id:[{required:true,message:'请选择残疾等级',tigger:'change'}],
        disability_number:[{required:true,message:'请输入残疾证号',tigger:'blur'},
          {required:true,validator:this.checkCjzh,tigger:'blur'}],
        viability_id:[{required:true,message:'请选择自理能力',tigger:'change'}],
        soical_ins_number:[{required:true,message:'请输入社会保障号',tigger:'blur'}],
        mobile:[{required:true,message:'请输入联系电话',tigger:'blur'},{required:true,pattern:/^[1][3,4,5,6,7,8,9][0-9]{9}$/,message:'请输入正确的手机号码',tigger:'blur'}],
        bank_type_id:[{required:true,message:'请选择银行类型',tigger:'change'}],
        bank_name:[{required:true,message:'请输入银行名称',tigger:'blur'}],
        bank_account_code:[{required:true,message:'请输入正确的银行卡号',tigger:'blur'}],
        bank_account_name:[{required:true,message:'请输入银行户名',tigger:'blur'}],
        bank_relation_id:[{required:true,message:'请选择与本人关系',tigger:'change'}],
        bank_person_uid:[{required:true,validator:this.checkUid,tigger:'blur'}],
        guardian_reqman_relation_id:[{required:true,message:'请选择与申请人关系',tigger:'change'}],
        blan_type:[{required:true,message:'请选择低保类别',tigger:'change'}],
        guardian_person_name:[{required:true,message:'请输入监护人姓名',tigger:'blur'}],
        guardian_person_uid:[{required:true,validator:this.checkUid,tigger:'blur'}],
        guardian_phone:[{required:true,message:'请输入监护人联系电话',tigger:'blur'},{required:true,pattern:/^[1][3,4,5,6,7,8,9][0-9]{9}$/,message:'请输入正确的手机号码',tigger:'blur'}]
      },
      photos:[
        {name:'委托书',type:'POWER_OF_ATTORNEY',required:false,limit:2,photos:[]},
        {name:'户口本户主页及家庭成员页',type:'PERMANENT_RESIDENCE_BOOKLET',required:false,limit:12,photos:[]},//
        // {name:'申请人身份证人像面及国徽面',type:'ID_CARD',required:false,photos:[]},//
        {name:'残疾人证',type:'DISABILITY_CERTIFICATE',required:false,limit:5,photos:[]},
        {name:'城乡居民最低生活保障证',type:'SECURITY_CERTIFICATE',required:false,limit:5,photos:[]},//
        {name:'银行卡',type:'BANK_CARD',required:false,limit:5,photos:[]},//
      ],
      disCan:true,
      addCan:false,
      delCan:false,
      blanApply:{
        archive_type_code:'',
        nav_name:'',
        canEdit:true,
        baseInfo:{
          apply_status:0,
          person_name:'',
          person_uid:'',
          apply_way:'',
          idcard_pic_front:'',
          idcard_pic_back:'',
          user_nations_id:'',
          user_nations:'',
          user_idcard_address:'',
          auth_person_uid:'',
          auth_person_name:'',
          auth_tel:'',
          to_party_id:'',
          req_reason:'',
          apply_source:'2',
          p_user_id:'',
          photo_id:'',


          mobile:'',
          emergency_mobile:'',
          emergency_name:'',
          emergency_relation_id:''

        },
        reqManInfo:{
          bank_card_type:'26100',
          open_document_type:'28931',
          is_guardian_person:1,
          bank_relation_id:'29031',
          blan_type:'',
          viability_id:'',
          party_id:'',
          party_name:'',
          mobile:'',
          is_blan:'',
          is_blan_name:'',
          bank_type_id:'',
          bank_name:'',
          bank_account_code:'',
          req_man_is:0,
          remark:'',
          serious_ill_id:'',
          dl_id:'',
          health_id:'',
          dt_id:'',
          org_nature_id:'',
          org_name:'',
          work_capacity_id:'',
          city_is:'',
          culture:'',
          relation_id:'',
          relation_name:'',
          disability_number:'',
          guardian_reqman_relation_id:'',
          guardian_reqman_relation_name:'',
          guardian_idcard_pic_front:'',
          guardian_idcard_pic_back:'',
          guardian_person_name:'',
          guardian_person_uid:'',
          guardian_phone:'',
          person_sex:1,
          person_birthday:'',
          person_age:'',
          person_uid:'',
          person_name:'',
         nations_type_id:'',
         nations_type_name:'',
         regi_address:'',
         living_address:'',
          // 政治面貌：
         politics:'1001',
         politics_name:'群众',
         soical_ins_number:'',
         idcard_pic_front:'',
         idcard_pic_back:'',
         bank_account_name:'',
         bank_person_uid:'',
         gsc_is:'0',
         marriage:'23001',
         marriage_name:'未婚',
          photo_id:'',
          dis_info:[
            {
              dl_id:'',
              dt_id:'',
              dt_name:'',
              dis_info_id:'',
              dl_name:''
            }
          ],
        },
        photos:[]
      },//包含baseeInfo(申报基本信息）
      idcard_pic_front:'',
      idcard_pic_front_img:'',
      idcard_pic_back:'',
      idcard_pic_back_img:'',


      idcard_pic_front_jf:'',
      idcard_pic_front_img_jf:'',
      idcard_pic_back_jf:'',
      idcard_pic_back_img_jf:'',


      isShow:true,
      apply_way:0,
      loginPerson:{
        person_name:'',
        person_uid:'',
        person_tel:'',
        isCertification:'',
        idcardPicFront:'',
        idcardPicBack:'',
        userIdcardAddress:'',
        userNationsId:'',
        userNations:'',
        photo_id:'',
      },
      frontFileList:[],
      backFileList:[],
      fmfrontFileList:[],
      fmbackFileList:[],
      city_is:[
        {name:'城市户口',id:1},
        {name:'农村户口',id:0}
      ],
      housing_type:[],
      house_type:[],
      proverty_causes:[],
      help_type:[],
      bank_type:[],
      bank_card_type:[],
      open_document_type:[],
      nations_type:[],relation:[],marital_status:[],political_status:[],regi_kind:[],
      education_levels:[],work_capacity:[],party_nature_type:[],health:[],serious_name:[],
      person_type:[],dis_type:[],dis_level:[],viability:[],
      is_blan_type:[
        {name:'是',id:'1'},
        {name:'否',id:'0'},
      ],
      is_guardian_person_type:[
        {name:'有',id:1},
        {name:'无',id:0},
      ],
      blan_type:[
        {name:'无',id:'0'},
      ],
      archive_type_code:'',

      guardianShow:false,
      temp_guardian_id:'',
      temp_guardian:{
        guardian_person_name:'',
        guardian_person_uid:'',
        guardian_phone:'',
        guardian_idcard_pic_front:'',
        guardian_idcard_pic_back:'',
        idcard_pic_back_img_jf:'',
        idcard_pic_front_img_jf:'',
        idcard_pic_front_jf:'',
        idcard_pic_back_jf:'',
      },
      bankRelationTemp:'',
      bankRelationTempArr:{
        bank_person_uid:'',
        bank_account_name:''
      },
    }
  } ,
  watch: {
    width(n,o){
      alert(n+'w')
    },
    height(n,o){
      alert(n+'h')
    },
    selectedRegion(nv){
      this.getDepartAreas(nv[nv.length-1],0);
    },
    selecteddepartOption(nv){
      // this.party_id=nv[nv.length-1];
      // this.blanApply.baseInfo.to_party_id=this.party_id;
      // this.blanApply.reqManInfo.party_id=this.party_id;

      if(nv && nv.length>0){
        this.blanApply.baseInfo.to_party_id=nv[nv.length-1];
        this.blanApply.reqManInfo.party_id=nv[nv.length-1];
      }
      else{
        this.blanApply.baseInfo.to_party_id='';
        this.blanApply.reqManInfo.party_id='';
      }
    },
    // party_id:function(){
    //   this.blanApply.baseInfo.to_party_id=this.party_id;
    //   this.blanApply.reqManInfo.party_id=this.party_id;
    // },
    'blanApply.reqManInfo.dis_info'(n,o){
      if(!this.disCan){
        if(this.blanApply.reqManInfo.dis_info){
          var length=this.blanApply.reqManInfo.dis_info.length;
          if(length<=2){
            this.addCan=true;
            this.delCan=false;
          }else{
            this.addCan=true;
            this.delCan=true;
          }
        }else{
          this.addCan=true;
          this.delCan=false;
        }
      }else{
        this.addCan=false;
        this.delCan=false;
      }

    },
    'blanApply.baseInfo.person_uid'(n,o){
      this.blanApply.reqManInfo.person_uid=n;
      this.blanApply.reqManInfo.relation_id="29031";
      this.blanApply.reqManInfo.relation_name="本人";
      this.blanApply.reqManInfo.soical_ins_number=n;
      if(this.blanApply.reqManInfo.bank_relation_id =='29031'){
        this.blanApply.reqManInfo.bank_person_uid=n;
      }
      this.loadEnjoyTreat();
    },
    'blanApply.baseInfo.person_name'(n,o){
      this.blanApply.reqManInfo.person_name=n;
      if(this.blanApply.reqManInfo.bank_relation_id =='29031'){
        this.blanApply.reqManInfo.bank_account_name=n;
      }
    },
    'blanApply.baseInfo.nations_type_id'(n,o){
      this.blanApply.reqManInfo.nations_type_id=this.blanApply.baseInfo.nations_type_id;
      this.blanApply.reqManInfo.nations_type_name=this.blanApply.baseInfo.nations_type_name;
    },
    'blanApply.baseInfo.user_idcard_address'(n,o){
      if(this.blanApply.baseInfo.user_idcard_address && this.blanApply.baseInfo.user_idcard_address!=''){
        this.blanApply.reqManInfo.regi_address=this.blanApply.baseInfo.user_idcard_address;
        this.blanApply.reqManInfo.living_address=this.blanApply.baseInfo.user_idcard_address;
      }
    },
    'blanApply.reqManInfo.person_uid'(n,o){
      if (this.$util.uid.validatorUid(n)){
        let age = this.$util.uid.getAgeByUid(n);
        let uidInfo=this.$util.uid.parse_person_uid(n)
        this.blanApply.reqManInfo.person_age = age+'';
        this.blanApply.reqManInfo.person_birthday=uidInfo.birthday;
        this.blanApply.reqManInfo.person_sex=uidInfo.sex;
      }
    },
  },
  created(){
    //判断是否登录没有，没登录的话，要求必须登录
    this.apply_id=this.$route.query.apply_id;
    this.archive_type_code=this.$route.query.archive_type_code;
    this.nav_name=this.$route.query.nav_name;
    this.canEditBoolean=this.$route.query.canEdit;
    if(this.canEditBoolean=='true'){
      this.canEditBoolean=true;
    }
    if(this.canEditBoolean=='false'){
      this.canEditBoolean=false;
    }
    this.blanApply.archive_type_code=this.archive_type_code;
    this.blanApply.nav_name=this.nav_name;
    this.blanApply.canEdit=this.canEditBoolean;
    // var userInfo=this.$cookies.get('userInfo')
    // if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1){
    //   this.loginShow=true;
    //   return;
    // }else {
    //   if(this.apply_id!=null && this.apply_id!=''&&this.apply_id!=undefined){
    //     this.loadApplyContent();
    //   }
    //   this.loadPersonInfo();
    //   // if (!this.party_id) {
    //   //   this.areaShow = true;
    //   // }
    //   var areaInfo=this.$cookies.get('areaInfo')
    //   if(!areaInfo || !areaInfo.departyId || areaInfo.departyId ==''){
    //     this.areaShow=true;
    //   }
    // }
  },
  mounted(){
    //获取applyId;
    var userInfo=this.$cookies.get('userInfo')
    if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1){
      this.loginShow=true;
      return;
    }else {
      if(this.apply_id!=null && this.apply_id!=''&&this.apply_id!=undefined){
        this.loadApplyContent();
      }else{
        this.initDepart();
      }
      this.loadPersonInfo();
    }
    // if(!this.party_id){
    //   this.areaShow=true;
    // }

    // this.initData();
    this.getDictData();
    this.getBankTypeData();
    this.getDisData();
  },
  methods: {
    parentFn(payload){

    },
    mobileChange(v){
      this.blanApply.baseInfo.mobile=v;
    },
    bankPersonUidChange(v){
      this.bankRelationTempArr.bank_person_uid=v;
    },
    bankPersonNameChange(v){
      this.bankRelationTempArr.bank_account_name=v;
    },
    bankRelationChange(v){
      if(this.bankRelationTemp==v){
        return;
      }
      this.bankRelationTemp=v;
      if(v=='29031'){
        this.blanApply.reqManInfo.bank_person_uid=this.blanApply.reqManInfo.person_uid;
        this.blanApply.reqManInfo.bank_account_name=this.blanApply.reqManInfo.person_name;
      }else{
        this.blanApply.reqManInfo.bank_person_uid=this.bankRelationTempArr.bank_person_uid;
        this.blanApply.reqManInfo.bank_account_name=this.bankRelationTempArr.bank_account_name;
      }
    },
    guardianPhoneChange(a){
      this.temp_guardian.guardian_phone=a;
    },
    getDisLevelLabel(a,b,c){
      if(c<=1){
        return a+"：";
      }else{
        return a+(b+1)+"：";
      }
    },
    getDisTypeLabel(a,b,c){
      if(c<=1){
        return a+"：";
      }else{
        return a+(b+1)+"";
      }
    },
    isBlanChange(v){
      if(v=='0'){
        this.blan_type=[  {name:'无',id:'0'}];
          this.blanApply.reqManInfo.blan_type='0';
      }else{
        this.blan_type=[
          {name:'城市低保',id:'blan_city'},
          {name:'农村低保',id:'blan_side'}];
        this.blanApply.reqManInfo.blan_type='';
      }
    },
    addDisCol(){
      this.blanApply.reqManInfo.dis_info.push({
        dl_id:'',
          dt_id:'',
          dt_name:'',
          dis_info_id:'',
          dl_name:''
      });
    },
    delDisCol(){
      this.blanApply.reqManInfo.dis_info.pop();
    },
    disabilityChange(){
      //判断位数是否为20位
      var disability_number=this.blanApply.reqManInfo.disability_number;
      if(disability_number.length !=20){
        this.blanApply.reqManInfo.dis_info=[{
          dl_id:'',
          dt_id:'',
          dt_name:'',
          dis_info_id:'',
          dl_name:''
        }];
        return ;
      }
      var type=disability_number.substring(18,19);
      var level=disability_number.substring(19,20);
      if(type>7 || level>4){
        this.blanApply.reqManInfo.dis_info=[{
          dl_id:'',
          dt_id:'',
          dt_name:'',
          dis_info_id:'',
          dl_name:''
        }];
        this.disCan=true;
        return;
      }
      if(type==7){
        this.disCan=false;
        if(this.blanApply.reqManInfo.dis_info.length<2){
          for(var i=0;i<2-this.blanApply.reqManInfo.dis_info.length;i++){
            this.blanApply.reqManInfo.dis_info.push({
              dl_id:'',
              dt_id:'',
              dt_name:'',
              dis_info_id:'',
              dl_name:''
            });
          }
        }
        return;
      }else{
        this.blanApply.reqManInfo.dis_info=[{
          dl_id:level,
          dt_id:type,
          dt_name:'',
          dis_info_id:'',
          dl_name:''
        }];
        this.disCan=true;
      }
    },
    checkUid(rule,value,callback){
      callback(this.$util.func.uid.check(value))
    },
    checkBankNum(rule,value,callback){
        callback(this.$util.func.bankNum.check(value))
    },
    checkCjzh(rule,value,callback){
      if(!value || value.length!=20){
        callback("请输入正确的残疾证号");
        return;
      }
      var type=value.substring(18,19);
      var level=value.substring(19,20);
      if(type>7 || level>4) {
        callback("请输入正确的残疾证号");
        return;
      }
      callback();
    },
    selectBankType(a){
      for(var i=0;i<this.bank_type.length;i++){
        if(this.bank_type[i].id==a){
          this.blanApply.reqManInfo.bank_name=this.bank_type[i].name;
          break;
        }
      }
    },

    relationChange(a){
      if(this.temp_guardian_id && this.temp_guardian_id !='' && this.temp_guardian_id == a){
        return;
      }
      this.temp_guardian_id=a;
      for(var i=0;i<this.relation.length;i++){
        if(this.relation[i].id==a){
          this.blanApply.reqManInfo.guardian_reqman_relation_name=this.relation[i].name;
          break;
        }
      }
      if(this.blanApply.reqManInfo.guardian_reqman_relation_name=='本人' || this.blanApply.reqManInfo.guardian_reqman_relation_name=='户主'){
        this.blanApply.reqManInfo.guardian_person_name=this.blanApply.reqManInfo.person_name;
        this.blanApply.reqManInfo.guardian_person_uid=this.blanApply.reqManInfo.person_uid;
        this.blanApply.reqManInfo.guardian_phone=this.blanApply.reqManInfo.mobile;
        this.blanApply.reqManInfo.guardian_idcard_pic_front=this.blanApply.reqManInfo.idcard_pic_front;
        this.blanApply.reqManInfo.guardian_idcard_pic_back=this.blanApply.reqManInfo.idcard_pic_back;

        this.idcard_pic_front_jf=this.blanApply.reqManInfo.idcard_pic_front;
        this.idcard_pic_back_jf=this.blanApply.reqManInfo.idcard_pic_back;

        this.guardianShow=true;
      }else{
        this.blanApply.reqManInfo.guardian_person_name=this.temp_guardian.guardian_person_name;
        this.blanApply.reqManInfo.guardian_person_uid=this.temp_guardian.guardian_person_uid;
        this.blanApply.reqManInfo.guardian_phone=this.temp_guardian.guardian_phone;
        this.blanApply.reqManInfo.guardian_idcard_pic_front=this.temp_guardian.guardian_idcard_pic_front;
        this.blanApply.reqManInfo.guardian_idcard_pic_back=this.temp_guardian.guardian_idcard_pic_back;
        this.idcard_pic_back_img_jf=this.temp_guardian.idcard_pic_back_img_jf;
        this.idcard_pic_front_img_jf=this.temp_guardian.idcard_pic_front_img_jf;
        this.idcard_pic_front_jf=this.temp_guardian.idcard_pic_front_jf;
        this.idcard_pic_back_jf=this.temp_guardian.idcard_pic_back_jf;
        if(this.idcard_pic_front_jf!='' && this.idcard_pic_back_jf !='' && this.blanApply.reqManInfo.guardian_person_uid!=''){
          this.guardianShow=true;
        }else{
          this.guardianShow=false;
        }
      }
    },
    relationChange_m(a){
      for(var i=0;i<this.relation.length;i++){
        if(this.relation[i].id==a){
          this.blanApply.currMember.relation_name=this.relation[i].name;
          break;
        }
      }
    },
    infoNext(a,b,c,d){
      var tt=this;
      tt.$refs['reqManInfo_ruleForm'].validate((valid) => {
        if (valid) {
          if(tt.blanApply.reqManInfo.disability_number && tt.blanApply.reqManInfo.disability_number.length ==20){
            //判断残疾人信息
            var type=tt.blanApply.reqManInfo.disability_number.substring(18,19);
            if(type==7){
              //判断残疾条数，必须大于等于2
              if(!tt.blanApply.reqManInfo.dis_info || tt.blanApply.reqManInfo.dis_info.length<2){
                tt.$alert("多重残疾至少两种残疾类型，请完善残疾类型信息!", "提示", {
                  confirmButtonText: '确定'});
                return false;
              }
            }
          }
          //判断监护人身份证信息是否上传，如果不上传不让提交
          if (tt.blanApply.reqManInfo.is_guardian_person==1 && tt.blanApply.reqManInfo.guardian_reqman_relation_name != '本人' && tt.blanApply.reqManInfo.guardian_reqman_relation_name != '户主'){
            if (tt.idcard_pic_front_jf == '' || this.idcard_pic_back_jf == '') {
              tt.qxAlertFlag=true;
              tt.alertMsg='请上传监护人身份证人像面、国徽面...';
              tt.alertType="error";
              return false;
            }
          }
          //判断银行卡号是否正确
          var p={
            bankId: tt.blanApply.reqManInfo.bank_type_id,
            bankCode: tt.blanApply.reqManInfo.bank_account_code,
            bank_card_type:tt.blanApply.reqManInfo.bank_card_type
          }
          tt.$https.post("api/ywt/base/checkBankNumber.do",p,(response)=> {
            if (response.data.code == 200 && response.data.data && response.data.data.dataobj) {
                if(response.data.data.dataobj.code !='200'){
                  //银行卡校验失败
                  tt.blanApply.reqManInfo.bank_account_code='';
                  tt.$alert(response.data.data.dataobj.msg, "银行卡校验失败", {
                    confirmButtonText: '确定'});
                  return false;
                }else{
                  tt.title_info=c;
                  tt.stepFlag=a;
                  tt.stepactive=b;
                }
            }else{
              tt.title_info=c;
              tt.stepFlag=a;
              tt.stepactive=b;
            }
          });
        }else{
          tt.$alert("您有必填项未完善，请完善后再继续下一步!", "提示", {
            confirmButtonText: '确定'});
          return false;
        }
      });
    },
    upStep(a,b,c,d){

      if(d && d=='master'){
        let members = this.blanApply.members;
        let master=this.blanApply.reqManInfo;
        master.req_man_is=1;
        var flag=true;
        for (let i=0;i<members.length;i++){
          if (members[i]!==undefined && members[i].req_man_is==1){
            members[i]=master;
            flag=false;
            break;
          }
        }
        if(flag){
        this.blanApply.members.push(master);
        }
      }
      this.title_info=c;
      this.stepFlag=a;
      this.stepactive=b;
    },
    handleClose(){
      this.smDialogShow=false;
      this.$router.back()
    },
    sureClose(){
      this.smDialogShow=false;
      this.urlTo('peopleCertification');
    },
    selectApplyType(item){
      if(item==this.apply_way){
        return ;
      }
      this.apply_way=item;
      if(item==0){
        this.person_uid_disable=1;
        //0表示本人办理，则把登录信息转移过来
         this.initToLoginPersonData();
         this.isShow=true;
      }else{
        this.person_uid_disable=0;
        //表示委托办理，需要上传身份证正面、背面做识别
        this.blanApply.baseInfo.person_uid='';
        this.blanApply.baseInfo.person_name='';
        this.blanApply.baseInfo.idcard_pic_front='';
        this.blanApply.baseInfo.idcard_pic_back='';
        this.blanApply.baseInfo.user_nations_id='';
        this.blanApply.baseInfo.photo_id='';
        this.blanApply.reqManInfo.mobile='';
        this.blanApply.baseInfo.user_nations='';

        this.blanApply.baseInfo.mobile='';
        this.blanApply.baseInfo.auth_tel=this.loginPerson.person_tel;

        this.blanApply.baseInfo.user_idcard_address='';
        this.blanApply.baseInfo.auth_person_uid=this.loginPerson.person_uid;
        this.blanApply.baseInfo.auth_person_name=this.loginPerson.person_name;

        this.idcard_pic_front='';
        this.idcard_pic_back='';
        this.idcard_pic_front_img='';
        this.idcard_pic_back_img='';
        this.blanApply.reqManInfo.idcard_pic_front='';
        this.blanApply.reqManInfo.photo_id='';
        this.blanApply.reqManInfo.idcard_pic_back='';

        this.isShow=false;
      }
    },
    getBankTypeData(){
      let data={
      };
      this.$https.post('api/ywt/base/getBankTypeData.do',data,response=>{
        if (response.data.code===200){
          this.bank_type=response.data.data.bankTypeList;
        }
      })
    },
    initToLoginPersonData(){
      this.blanApply.baseInfo.person_uid=this.loginPerson.person_uid;
      this.blanApply.baseInfo.person_name=this.loginPerson.person_name;
      this.blanApply.baseInfo.idcard_pic_front=this.loginPerson.idcardPicFront;
      this.blanApply.baseInfo.idcard_pic_back=this.loginPerson.idcardPicBack;
      this.blanApply.baseInfo.user_nations_id=this.loginPerson.userNationsId;
      this.blanApply.baseInfo.user_nations=this.loginPerson.userNations;
      this.blanApply.baseInfo.user_idcard_address=this.loginPerson.userIdcardAddress;
      this.blanApply.baseInfo.auth_person_uid=this.loginPerson.person_uid;
      this.blanApply.baseInfo.auth_person_name=this.loginPerson.person_name;
      this.blanApply.baseInfo.photo_id=this.loginPerson.photo_id;
      this.idcard_pic_front=this.loginPerson.idcardPicFront;
      this.idcard_pic_back=this.loginPerson.idcardPicBack;
      this.blanApply.reqManInfo.idcard_pic_front=this.loginPerson.idcardPicFront;
      this.blanApply.reqManInfo.idcard_pic_back=this.loginPerson.idcardPicBack;
      this.blanApply.reqManInfo.photo_id=this.loginPerson.photo_id;
      this.blanApply.reqManInfo.disability_number=this.loginPerson.person_uid;


      this.blanApply.baseInfo.auth_tel=this.loginPerson.person_tel;
      this.blanApply.baseInfo.mobile=this.loginPerson.person_tel;
    },
    initReqManInfo(){
      this.blanApply.reqManInfo.nations_type_id=this.loginPerson.userNationsId;
      this.blanApply.reqManInfo.nations_type_name=this.loginPerson.userNations;
      this.blanApply.reqManInfo.regi_address=this.loginPerson.userIdcardAddress;
      this.blanApply.reqManInfo.living_address=this.loginPerson.userIdcardAddress;
      this.blanApply.reqManInfo.photo_id=this.loginPerson.photo_id;
      // 政治面貌：
      this.blanApply.reqManInfo.politics='1001';
      this.blanApply.reqManInfo.politics_name='群众';
      this.blanApply.reqManInfo.soical_ins_number=this.loginPerson.person_uid;
      this.blanApply.reqManInfo.mobile=this.loginPerson.person_tel;

      this.blanApply.reqManInfo.idcard_pic_front=this.loginPerson.idcardPicFront;
      this.blanApply.reqManInfo.idcard_pic_back=this.loginPerson.idcardPicBack;

      this.blanApply.reqManInfo.bank_account_name=this.loginPerson.person_name;
      this.blanApply.reqManInfo.bank_person_uid=this.loginPerson.person_uid;

      this.blanApply.reqManInfo.is_blan='0';
      this.blanApply.reqManInfo.is_blan_name='否';

      this.blanApply.reqManInfo.blan_type='0';

      // this.blanApply.reqManInfo.income_wages=0;
      // this.blanApply.reqManInfo.income_pension=0;
      // this.blanApply.reqManInfo.income_odd_job=0;
      // this.blanApply.reqManInfo.income_unemployment_insurance=0;
      // this.blanApply.reqManInfo.income_living_expenses=0;
      // this.blanApply.reqManInfo.income_rent=0;
      // this.blanApply.reqManInfo.income_operating=0;
      // this.blanApply.reqManInfo.income_alimony=0;
      // this.blanApply.reqManInfo.income_raise=0;
      // this.blanApply.reqManInfo.income_other=0;

      this.blanApply.reqManInfo.gsc_is='0';
      this.blanApply.reqManInfo.marriage='23001';
      this.blanApply.reqManInfo.marriage_name='未婚';
    },
    loadApplyContent(){
      if(this.apply_id==''||this.apply_id==undefined){
        this.initDepart();
        return ;
      }
      let data={
        apply_id:this.apply_id,
        archive_type_code:this.archive_type_code
      };
      var tttt=this;
      this.$https.post("api/ywt/apply/getApplyClp.do",data,(response)=>{
        if (response.data.code!==200){
         // tttt.$toast.fail(response.data.msg)
        }else {
          let rtData=response.data.data.applyContent;
          tttt.blanApply.baseInfo=rtData.baseInfo;
          if(rtData.clpInfo){
            var disability_number=rtData.clpInfo.disability_number;
            if(disability_number){
              var type=disability_number.substring(18,19);
              if(type==7){
                tttt.disCan=false;
              }
            }
            if(rtData.is_blan=='0'){
              this.blan_type=[  {name:'无',id:'0'}];
            }else{
              this.blan_type=[
                {name:'城市低保',id:'blan_city'},
                {name:'农村低保',id:'blan_side'}];
            }
          tttt.blanApply.reqManInfo=rtData.clpInfo;
          }

          if(rtData.baseInfo && rtData.baseInfo.to_party_id){
            //异步获取区划信息
            tttt.party_id=rtData.baseInfo.to_party_id;
            tttt.party_ids(rtData.baseInfo.to_party_id);
          }else{
            tttt.initDepart();
          }

          let localPhotos=rtData.photos;
          let photoTypes = tttt.photos;//tttt.blanApply.photos;
          let typeLength = photoTypes.length;
          for (let i=0;i<typeLength;i++){
            photoTypes[i].photos=[];
            let typeName = photoTypes[i].type;
            if (localPhotos[typeName]&&localPhotos[typeName].length>0){
              photoTypes[i].checked=true;
              for (let j=0;j<localPhotos[typeName].length;j++){
                photoTypes[i].photos.push(localPhotos[typeName][j])
              }
            }
          }
          // tttt.photos=tttt.blanApply.photos;
          tttt.idcard_pic_front=tttt.blanApply.baseInfo.idcard_pic_front;
          tttt.idcard_pic_back=tttt.blanApply.baseInfo.idcard_pic_back;

          if(tttt.idcard_pic_front && tttt.idcard_pic_front!=''){
            var imgUrl=tttt.getImg(tttt.idcard_pic_front);
            tttt.idcard_pic_front_img=imgUrl;
          }
          if(tttt.idcard_pic_back && tttt.idcard_pic_back!=''){
            var imgUrl=tttt.getImg(tttt.idcard_pic_back);
            tttt.idcard_pic_back_img=imgUrl;
          }
          tttt.idcard_pic_front_jf=tttt.blanApply.reqManInfo.guardian_idcard_pic_front;
          tttt.idcard_pic_back_jf=tttt.blanApply.reqManInfo.guardian_idcard_pic_back;

          if(tttt.idcard_pic_front_jf && tttt.idcard_pic_front_jf!=''){
            tttt.idcard_pic_front_img_jf=tttt.getImg(tttt.idcard_pic_front_jf);
          }
          if(tttt.idcard_pic_back_jf && tttt.idcard_pic_back_jf!=''){
            tttt.idcard_pic_back_img_jf=tttt.getImg(tttt.idcard_pic_back_jf);
          }
          if(tttt.blanApply.reqManInfo.bank_relation_id !='29031'){
           tttt.bankRelationTempArr.bank_person_uid= tttt.blanApply.reqManInfo.bank_person_uid;
           tttt.bankRelationTempArr.bank_account_name=tttt.blanApply.reqManInfo.bank_account_name;
          }
          if(tttt.blanApply.reqManInfo.is_guardian_person==1 && tttt.blanApply.reqManInfo.guardian_reqman_relation_id !='29031'){
            tttt.temp_guardian.guardian_person_name=tttt.blanApply.reqManInfo.guardian_person_name;
            tttt.temp_guardian.guardian_person_uid=tttt.blanApply.reqManInfo.guardian_person_uid;
            tttt.temp_guardian.guardian_idcard_pic_front=tttt.blanApply.reqManInfo.guardian_idcard_pic_front;
            tttt.temp_guardian.guardian_idcard_pic_back=tttt.blanApply.reqManInfo.guardian_idcard_pic_back;
            tttt.temp_guardian.idcard_pic_back_img_jf=tttt.idcard_pic_back_img_jf;
            tttt.temp_guardian.idcard_pic_front_img_jf=tttt.idcard_pic_front_img_jf;
            tttt.temp_guardian.idcard_pic_front_jf=tttt.blanApply.reqManInfo.guardian_idcard_pic_front;
            tttt.temp_guardian.idcard_pic_back_jf=tttt.blanApply.reqManInfo.guardian_idcard_pic_back;
            tttt.temp_guardian.guardian_phone=tttt.blanApply.reqManInfo.guardian_phone;
          }
        }
      });
    },
    loadPersonInfo(){
      var tt=this;
      this.$https.post("api/pu/peopleUserInfo.do",{},response=>{
        if (response.status === 200 && response.data.code===200) {
          if(response.data.data.isCertification == '1'){
            tt.loginPerson.person_name=response.data.data.userName;
            tt.loginPerson.person_uid=response.data.data.userIdcard;
            tt.loginPerson.person_tel=response.data.data.userTel;
            tt.loginPerson.isCertification=response.data.data.isCertification;
            tt.loginPerson.idcardPicFront=response.data.data.idcardPicFront;
            tt.loginPerson.idcardPicBack=response.data.data.idcardPicBack;
            tt.loginPerson.userIdcardAddress=response.data.data.userIdcardAddress;
            tt.loginPerson.userNationsId=response.data.data.userNationsId;
            tt.loginPerson.userNations=response.data.data.userNations;
            tt.loginPerson.photo_id=response.data.data.idcardPhoto;
            if(tt.apply_id!=null && tt.apply_id!=''&&tt.apply_id!=undefined){
            }else{
              //初始化数据，默认本人办理
              if(tt.blanApply.baseInfo.apply_way==null || tt.blanApply.baseInfo.apply_way==''){
                tt.apply_way=0;
                tt.blanApply.baseInfo.apply_way=0;
                tt.initToLoginPersonData();
                tt.initReqManInfo();
              }
            }
          }else{
            //跳转去实名认证
              tt.smDialogShow=true;
          }
        } else {
          tt.$router.push({path:'/peopleLogin'});
        }
      });
    },
    getImg(imgId){
      var dd=this.$util.req.getshowImg(imgId);
      return dd;
    },
    afterReadOne(files){
      if(files){
        this.isShow=false;
        files.status = 'uploading';
        files.message = '上传中...';
        files.type='idcard_pic_front';
        files.attrName="ic_"+this.$util.uuid.uuid2();
        this.alertMsg='身份证人像面上传中...';
        this.alertType="warning";
        this.qxAlertFlag=true;
        this.idcard_pic_front_img='';
        this.idcard_pic_front='';
        this.compressImg(files);
        // this.afterReadFile(files);
      }
    },
    afterReadTwo(files){
      if(files) {
        this.isShow=false;
        files.status = 'uploading';
        files.message = '上传中...';
        files.type='idcard_pic_back';
        files.attrName="ic_"+this.$util.uuid.uuid2();
        this.alertMsg='身份证国徽面上传中...';
        this.alertType="warning";
        this.qxAlertFlag=true;
        this.idcard_pic_back_img='';
        this.idcard_pic_back='';
        this.compressImg(files);

        // this.afterReadFile(files);
      }
    },

    afterReadOne_m(files){
      if(files){
        // this.isShow=false;
        files.status = 'uploading';
        files.message = '上传中...';
        files.type='idcard_pic_front';
        files.attrName="ic_"+this.$util.uuid.uuid2();
        files.ss='m';//表示家庭成员信息
        this.alertMsg='身份证人像面上传中...';
        this.alertType="warning";
        this.qxAlertFlag=true;
        this.idcard_pic_front_img_jf='';
        this.idcard_pic_front_jf='';
        this.compressImg(files);
        // this.afterReadFile(files);
      }
    },
    afterReadTwo_m(files){
      if(files) {
        // this.isShow=false;
        files.ss='m';//表示家庭成员信息
        files.status = 'uploading';
        files.message = '上传中...';
        files.type='idcard_pic_back';
        files.attrName="ic_"+this.$util.uuid.uuid2();
        this.alertMsg='身份证国徽面上传中...';
        this.alertType="warning";
        this.qxAlertFlag=true;
        this.idcard_pic_back_img_jf='';
        this.idcard_pic_back_jf='';

        this.compressImg(files);

        // this.afterReadFile(files);
      }
    },
    compressImg(file) {
      var t=this;
      if(/\/(?:jpeg|png)/i.test(file.file.type)&&file.file.size>2097152) {
        this.photoCompress(file,{
          quality: 0.5
        },function (base64Codes) {
          var bl = t.convertBase64UrlToBlob(base64Codes);
          let bytes=atob(base64Codes.split(',')[1]);        //去掉url的头，并转换为byte
          //处理异常,将ascii码小于0的转换为大于0
          let ab = new ArrayBuffer(bytes.length);
          let ia = new Uint8Array(ab);
          for (let i = 0; i < bytes.length; i++) {
            ia[i] = bytes.charCodeAt(i);
          }
          let fileItem = new File([ab],new Date().getTime()+'.jpg',{type:'image/jpg'});
          if(fileItem){
            file.file=fileItem;
            t.afterReadFile(file);
          }
        })
      }else{
        this.afterReadFile(file);
      }
    },
    /**
     * @param file: 上传的图片
     * @param objCompressed：压缩后的图片规格
     * @param objDiv：容器或回调函数
     */
    photoCompress(file, objCompressed, objDiv){
  var ready=new FileReader();
  ready.readAsDataURL(file.file);
  var tt=this;
  ready.onload=function(){
    var fileResult=this.result;
    tt.canvasDataURL(fileResult,objCompressed,objDiv)
  }
},

canvasDataURL(path, objCompressed, callback) {
  var img = new Image();
  img.src = path;
  img.onload = function () {
    var that = this;
    //默认压缩后图片规格
    var quality = 0.5;
    var w = that.width;
    var h = that.height;
    var scale = w / h;
    //实际要求
    w = objCompressed.width || w;
    h = objCompressed.height || (w / scale);
    if(objCompressed.quality && objCompressed.quality > 0 && objCompressed.quality <= 1){
      quality = objCompressed.quality;
    }
    //生成canvas
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    // 创建属性节点
    var anw = document.createAttribute("width");
    anw.nodeValue = w;
    var anh = document.createAttribute("height");
    anh.nodeValue = h;
    canvas.setAttributeNode(anw);
    canvas.setAttributeNode(anh);
    ctx.drawImage(that, 0, 0, w, h);

    var base64 = canvas.toDataURL('image/jpeg', quality);
    // 回调函数返回base64的值
    callback(base64);
  }
},

convertBase64UrlToBlob(urlData) {
  var arr = urlData.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
  while(n--){
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {type:mime});
},


















    afterReadFile(file){
      file.status='uploading';
      let formData = new FormData;
      formData.append('_sk','app');
      formData.append('upload',file.file);
      formData.append('type',file.type);
      formData.append('attachName',"ic_"+this.$util.uuid.uuid2());
      var ttt=this;
      this.$https.postFile('attach/upload.do',formData,(response)=>{
        if (response.status===200&&response.data.isOk){
          // file.attachId=response.data.bean.attach_id;
          if(file.type=='idcard_pic_front'){
            if(!file.ss && file.ss !='m'){
              ttt.idcard_pic_front=response.data.bean.attach_id;
              ttt.idcard_pic_front_img=ttt.getImg(ttt.idcard_pic_front);
            }else{
                ttt.idcard_pic_front_jf=response.data.bean.attach_id;
                ttt.idcard_pic_front_img_jf=ttt.getImg(ttt.idcard_pic_front_jf);
            }
            ttt.qxAlertFlag=true;
            ttt.alertMsg='身份证人像面上传完成...';
            ttt.alertType="warning";
          }else{
            if(!file.ss && file.ss !='m') {
              ttt.idcard_pic_back = response.data.bean.attach_id;
              ttt.idcard_pic_back_img = ttt.getImg(ttt.idcard_pic_back);
            }else{
              ttt.idcard_pic_back_jf=response.data.bean.attach_id;
              ttt.idcard_pic_back_img_jf=ttt.getImg(ttt.idcard_pic_back_jf);
            }
            ttt.qxAlertFlag=true;
            ttt.alertMsg='身份证国徽面上传完成...';
            ttt.alertType="warning";
          }
          file.status='done'
          if(!file.ss && file.ss !='m') {
            ttt.uploadOver(ttt.idcard_pic_front,ttt.idcard_pic_back,'apply');
          }else{
            ttt.uploadOver(ttt.idcard_pic_front_jf,ttt.idcard_pic_back_jf,'m');
          }
        }else {
          file.status='failed';
          ttt.alertMsg='图片上传失败，请重新选择文件上传...';
          ttt.alertType="error";
        }
      });
      //重新验证表单项
      // this.$refs['photo'].resetValidation();
    },
    uploadOver(idcard_pic_front,idcard_pic_back,sources){
      if(idcard_pic_front!='' && idcard_pic_back !=''){
        this.qxAlertFlag=true;
        this.alertMsg='身份证信息识别中，请稍后......';
        this.alertType="warning";
        //上传正面照
        var ttt=this;
        this.$https.post('api/pu/getIdCardFromPic.do',{attr_id:idcard_pic_front},(response)=>{
          if (response.status===200&&response.data.code==200){
            if(response.data.data.ocr_success){
              //判断身份照背面是否合法
              ttt.$https.post('api/pu/getIdCardFromPic.do',{attr_id:idcard_pic_back},(response_back)=>{
                if(response_back.data.data.ocr_success){
                  if(sources !='m'){
                    if(response.data.data.headImg && response.data.data.headImg !=''){
                      let bytes=atob(response.data.data.headImg);        //去掉url的头，并转换为byte
                      //处理异常,将ascii码小于0的转换为大于0
                      let ab = new ArrayBuffer(bytes.length);
                      let ia = new Uint8Array(ab);
                      for (let i = 0; i < bytes.length; i++) {
                        ia[i] = bytes.charCodeAt(i);
                      }
                      let fileItem = new File([ab],new Date().getTime()+'.jpg',{type:'image/jpg'});
                      let formData = new FormData;
                      formData.append('_sk','app');
                      formData.append('upload',fileItem);
                      formData.append('type',"archivePhoto");
                      formData.append('attachName',"head_"+this.$util.uuid.uuid2());
                      ttt.$https.postFile('attach/upload.do',formData,(responseaa)=> {
                        if (responseaa.status === 200 && responseaa.data.isOk) {
                          ttt.blanApply.baseInfo.photo_id=responseaa.data.bean.attach_id;
                          ttt.blanApply.reqManInfo.photo_id=responseaa.data.bean.attach_id;
                        }
                      });
                    }
                    ttt.blanApply.baseInfo.idcard_pic_front=idcard_pic_front;
                    ttt.blanApply.baseInfo.idcard_pic_back=idcard_pic_back;
                    ttt.blanApply.baseInfo.person_uid=response.data.data.person_uid;
                    ttt.blanApply.baseInfo.person_name=response.data.data.person_name;
                    ttt.blanApply.baseInfo.user_nations_id=response.data.data.nations_type_id;
                    ttt.blanApply.baseInfo.user_nations=response.data.data.nation_str;
                    ttt.blanApply.baseInfo.user_idcard_address=response.data.data.reg_address;
                    ttt.blanApply.reqManInfo.idcard_pic_front=idcard_pic_front;
                    ttt.blanApply.reqManInfo.idcard_pic_back=idcard_pic_back;
                    //ttt.blanApply.reqManInfo.disability_number=this.loginPerson.person_uid;
                    ttt.blanApply.reqManInfo.disability_number=response.data.data.person_uid;
                    ttt.isShow=true;
                  }else{
                    ttt.blanApply.reqManInfo.guardian_idcard_pic_front=idcard_pic_front;
                    ttt.blanApply.reqManInfo.guardian_idcard_pic_back=idcard_pic_back;
                    ttt.blanApply.reqManInfo.guardian_person_name=response.data.data.person_name;
                    ttt.blanApply.reqManInfo.guardian_person_uid=response.data.data.person_uid;

                    ttt.temp_guardian.guardian_person_name=response.data.data.person_name;
                    ttt.temp_guardian.guardian_person_uid=response.data.data.person_uid;
                    ttt.temp_guardian.guardian_idcard_pic_front=idcard_pic_front;
                    ttt.temp_guardian.guardian_idcard_pic_back=idcard_pic_back;
                    ttt.temp_guardian.idcard_pic_back_img_jf=ttt.idcard_pic_back_img_jf;
                    ttt.temp_guardian.idcard_pic_front_img_jf=ttt.idcard_pic_front_img_jf;
                    ttt.temp_guardian.idcard_pic_front_jf=idcard_pic_front;
                    ttt.temp_guardian.idcard_pic_back_jf=idcard_pic_back;
                    ttt.guardianShow=true;
                  }
                  ttt.alertMsg='';
                  ttt.alertType="success";
                  this.qxAlertFlag=false;
                }else{
                  if(sources !='m'){
                    ttt.isShow=false;
                    ttt.idcard_pic_back='';
                    ttt.idcard_pic_back_img='';
                    ttt.blanApply.reqManInfo.idcard_pic_front='';
                    ttt.blanApply.reqManInfo.idcard_pic_back='';
                  }else{
                    ttt.fmbackFileList=[];
                    ttt.guardianShow=false;
                    ttt.idcard_pic_back_jf='';
                    ttt.idcard_pic_back_img_jf='';
                    ttt.blanApply.reqManInfo.guardian_idcard_pic_back=''
                  }
                  ttt.alertMsg='身份证国徽面识别失败，请重新上传！';
                  ttt.alertType="error";
                  this.qxAlertFlag=true;
                }
              });
            }else{
              // fmfrontFileList:[],
              if(sources !='m'){
                ttt.idcard_pic_front='';
                ttt.idcard_pic_front_img='';
                ttt.idcard_pic_back='';
                ttt.idcard_pic_back_img='';
                ttt.blanApply.reqManInfo.idcard_pic_front='';
                ttt.blanApply.reqManInfo.idcard_pic_back='';
                ttt.blanApply.baseInfo.person_uid='';
                ttt.blanApply.baseInfo.person_name='';
                ttt.blanApply.baseInfo.user_nations_id='';
                ttt.blanApply.baseInfo.user_nations='';
                ttt.blanApply.baseInfo.user_idcard_address='';
                ttt.blanApply.baseInfo.idcard_pic_front='';
                ttt.blanApply.baseInfo.idcard_pic_back='';
                ttt.isShow=false;
              }else{
                ttt.fmfrontFileList=[];
                ttt.fmbackFileList=[];
                ttt.guardianShow=false;
                ttt.idcard_pic_back_jf='';
                ttt.idcard_pic_back_img_jf='';
                ttt.blanApply.reqManInfo.guardian_idcard_pic_back=''

                ttt.idcard_pic_front_jf='';
                ttt.idcard_pic_front_img_jf='';
                ttt.blanApply.reqManInfo.guardian_idcard_pic_front=''
              }
              //身份证信息读取失败，要求重新上传
              ttt.alertMsg='身份证信息识别失败，请重新上传！';
              ttt.alertType="error";
            }
          }
        });
      }
    },
    applyNextStep(){
      if(this.idcard_pic_front=='' || this.idcard_pic_back ==''){
        this.qxAlertFlag=true;
        this.alertMsg='请上传身份证人像面、国徽面!';
        this.alertType="error";
        return false;
      }
      if(this.blanApply.baseInfo.person_name ==''){
        this.qxAlertFlag=true;
        this.alertMsg='请输入申请人名称!';
        this.alertType="error";
        return false;
      }
      if(this.blanApply.baseInfo.person_uid ==''){
        this.qxAlertFlag=true;
        this.alertMsg='请输入身份证号!';
        this.alertType="error";
        return false;
      }

      if(this.blanApply.baseInfo.emergency_name ==''){
        this.qxAlertFlag=true;
        this.alertMsg='请输入紧急联系人姓名!';
        this.alertType="error";
        return false;
      }
      if(this.blanApply.baseInfo.emergency_mobile ==''){
        this.qxAlertFlag=true;
        this.alertMsg='请输入紧急联系电话!';
        this.alertType="error";
        return false;
      }
      if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.blanApply.baseInfo.emergency_mobile)) {
        this.qxAlertFlag=true;
        this.alertMsg='请输入正确紧急联系电话!';
        this.alertType="error";
        return false;
      }
      if(this.blanApply.baseInfo.emergency_relation_id ==''){
        this.qxAlertFlag=true;
        this.alertMsg='请选择紧急联系人与申请人关系!';
        this.alertType="error";
        return false;
      }
      if(this.blanApply.baseInfo.req_reason ==''){
        this.qxAlertFlag=true;
        this.alertMsg='请输入申请原因!';
        this.alertType="error";
        return false;
      }
      this.title_info="提交基本信息",
        this.qxAlertFlag=false;
        this.alertMsg='';
        this.alertType="";
        this.stepFlag='reqManInfo';
        this.stepactive=0;
    }
    ,
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleClick(){},
    reloadPage(){
      this.reload();
    },
    loadEnjoyTreat(){
      this.$https.post("api/zj/getEnjoyTreat.do",{person_uid:this.blanApply.baseInfo.person_uid},response=>{
        if (response.status === 200 && response.data.code===200) {
          this.enjoy_treat=response.data.data.enjoy_treat;
        } else {
          // this.$toast.fail(response.data.msg)
        }
      });
    },
    getPartyId(a){
      if(this.party_id){
        return;
      }
      return;
      if(a){
       this.party_id=a;
       // this.reload();
        var areaInfo=this.$cookies.get('areaInfo')
        if(areaInfo && areaInfo.departyId && areaInfo.departyId !=''){
          if(areaInfo.provinceId){
            this.selectedRegion[0]=areaInfo.provinceId;
          }
          if(areaInfo.cityId){
            this.selectedRegion[1]=areaInfo.cityId;
          }
          if(areaInfo.areaId){
            this.selectedRegion[2]=areaInfo.areaId;
          }
          if(this.selectedRegion.length>0){
            this.getDepartAreas(this.selectedRegion[this.selectedRegion.length-1],0);
          }
          if(areaInfo.departyId){
            this.selecteddepartOption[0]=areaInfo.departyId
            this.blanApply.baseInfo.to_party_id=areaInfo.departyId;
            this.blanApply.reqManInfo.party_id=areaInfo.departyId;
            // if(this.getPartyId){
            //   this.getPartyId(areaInfo.departyId);
            // }
          }
          // this.areaName=_userAreaName;
        }
      }
    },
    getImg(imgId){
      var dd=this.$util.req.getshowImg(imgId);
      return dd;
    },
    getDepartAreas(ParentId,index){
      const options={pid:ParentId}
      var t=this;
      this.$https.post("api/pu/getPartyByParentAreaCode.do",options,response=>{
        if (response.status === 200 && response.data.code===200) {
          t.departOption = Object.values(response.data.data).map(function(e){
            return {label:e.name,value:e.code,leaf:true}
          })
        } else {
          t.departOption =[];
        }
      })
    },
    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    },
    getDisData(){
      let data={
      };
      var tt=this;
      this.$https.post('api/ywt/base/getDisData.do',data,response=>{
        if (response.data.code===200){
          tt.dis_type=response.data.data.disTypeList;
          tt.dis_level=response.data.data.disLevelList;
        }
      })
    },
    getDictData(){
      let data={
        types:['nations_type','relation','marital_status','political_status','regi_kind',
          'education_levels','work_capacity','party_nature_type','health','serious_name','bank_card_type','open_document_type',
          'person_type','viability']
      };
      this.$https.post('api/ywt/base/getDictData.do',data,response=>{
        if (response.data.code===200){
          this.$util.readData(response.data.data,this)
        }
      })
    },
    editMember(member,index){
      member.__index=index;
      this.blanApply.currMember=member;
      var idcard_pic_front=this.blanApply.currMember.idcard_pic_front;
      var idcard_pic_back=this.blanApply.currMember.idcard_pic_back;
      if(idcard_pic_front && idcard_pic_front!=''){
        var imgUrl=this.getImg(idcard_pic_front);
        this.blanApply.currMember.idcard_pic_front_img=imgUrl;
        // console.log(this.user_idcard_one_file)
      }
      if(idcard_pic_back && idcard_pic_back!=''){
        var imgUrl=this.getImg(idcard_pic_back);
        this.blanApply.currMember.idcard_pic_back_img=imgUrl;
      }
        this.blanApply.currMember.isShow=true;
      this.familyUserDialog=true;
    },
    addMember(){
      this.blanApply.currMember={},
      this.blanApply.currMember={
          politics:'1001',
          politics_name:'群众',
          income_wages:0,
          income_pension:0,
          income_odd_job:0,
          income_unemployment_insurance:0,
          income_living_expenses:0,
          income_rent:0,
          income_operating:0,
          income_alimony:0,
          income_raise:0,
          income_other:0,
          marriage:'23001',
          marriage_name:'未婚',
          idcard_pic_front:'',
          idcard_pic_back:'',
          idcard_pic_front_img:'',
          idcard_pic_back_img:'',
          isShow:false,
      };
      this.familyUserDialog=true;
    },
    delMember(index,member){
      this.$dialog.confirm({title:'提示',message:'确定删除吗?',confirmButtonColor:'red'})
        .then(() => {
          this.blanApply.members.splice(index,1)
        })
        .catch(() => {

        });

    },
    saveMember(){
      if(this.blanApply.currMember.__index==undefined){
        this.blanApply.members.push(this.blanApply.currMember)
      }else{
        let currMember=this.blanApply.currMember;
        this.blanApply.members.map(function (m){
          if(m.__index==currMember.__index){
            return currMember;
          }else{
            return m;
          }
        });
      }
      this.familyUserDialog=false
    },
    onSave(){
      this.blanApply.baseInfo.apply_status=0;
      this.is_submit=false;
      this.save();
    },
    onSubmit(){
      this.blanApply.baseInfo.apply_status=5;
      this.is_submit=true;
      this.save();
    },
    save(){
      //构建图片数据结构
      let photos={};
      let length = this.photos.length;
      for (let i=0;i<length;++i){
        let photoType = this.photos[i];
        if (photoType.photos&&photoType.photos.length!=0){
          photos[photoType.type]=[];
          for (let j=0;j<photoType.photos.length;j++){
            if (photoType.photos[j]){
              photos[photoType.type].push(photoType.photos[j])
            }
          }
        }else {
          photos[photoType.type]=[];
        }
      }
      // photos['ID_CARD']=[];
      // photos['ID_CARD'].push(this.blanApply.baseInfo.idcard_pic_front);
      // photos['ID_CARD'].push(this.blanApply.baseInfo.idcard_pic_back);

      let applyContent={
        submit_is:this.is_submit,
        baseInfo:this.blanApply.baseInfo,
        clpInfo:this.blanApply.reqManInfo,
        archive_type_code:this.archive_type_code,
        photos:photos
      };

      //保存数据，并进入下一个页面,保存数据后初始化store数据
      var loading = this.$loading({
        lock: true,
        text: '数据提交中,请耐心等待....',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      //初始化一些参数
      applyContent.baseInfo.archive_type_code=this.blanApply.archive_type_code;
      applyContent.clpInfo.archive_type_code=this.blanApply.archive_type_code;
      applyContent.baseInfo.p_user_id=this.$cookies.get('userId');
      let data={
        applyContent: applyContent
      };
      var tt=this;
      this.$https.post('api/ywt/apply/saveApplyClp.do',data,(response)=>{
        if (response.data.code!==200){
          loading.close();
          tt.$alert(response.data.msg, "【"+tt.nav_name+"】"+(tt.is_submit?"提交失败！":"保存失败！"), {
            confirmButtonText: '确定'});
        }else {
          loading.close();
          if(tt.is_submit){
            tt.$alert('您可以通过:【个人中心->我的办件】查看进度', "【"+tt.nav_name+"】提交成功", {
              confirmButtonText: '确定'
            }).then(() => {
              tt.$router.back();
            });
          }else{
            tt.$alert('您可以通过:【个人中心->我的办件】查看保存的信息，并继续填报',"【"+tt.nav_name+"】保存成功", {
              confirmButtonText: '确定'
            }).then(() => {
              tt.$router.back();
            });
          }

        }
      });
    },
    party_ids(nv){
      var tt=this;
      this.$https.post("api/pu/getPuUserAreaByPartyId.do",{partyId:nv},(response)=>{
        if (response.status === 200 && response.data.code==200 && response.data.data){
          var csData=[];
          if(response.data.data.provinceId){
            csData[0]=response.data.data.provinceId;
          }
          if(response.data.data.cityId){
            csData[1]=response.data.data.cityId;
          }
          if(response.data.data.areaId){
            csData[2]=response.data.data.areaId;
          }
          tt.selectedRegion=csData;
          let cs=tt.$refs['cs2'];
          cs.panel.activePath=[];
          cs.panel.loadCount=0;
          cs.panel.lazyLoad();
          if(tt.selectedRegion.length>0){
            tt.getDepartAreas(tt.selectedRegion[tt.selectedRegion.length-1],0);
          }
          if(response.data.data.departyId){
            tt.selecteddepartOption[0]=response.data.data.departyId
            tt.blanApply.baseInfo.to_party_id=response.data.data.departyId;
            tt.blanApply.reqManInfo.party_id=response.data.data.departyId;
            // if(this.getPartyId){
            //   this.getPartyId(areaInfo.departyId);
            // }
          }

        }
      });
    },
    initDepart(){
      var areaInfo = this.$cookies.get('areaInfo')
      if (areaInfo && areaInfo.departyId && areaInfo.departyId != '') {
        var csData=[];
        if (areaInfo.provinceId) {
          csData[0] = areaInfo.provinceId;
        }
        if (areaInfo.cityId) {
          csData[1] = areaInfo.cityId;
        }
        if (areaInfo.areaId) {
          csData[2] = areaInfo.areaId;
        }
        if (this.selectedRegion.length > 0) {
          this.getDepartAreas(this.selectedRegion[this.selectedRegion.length - 1], 0);
        }
        this.selectedRegion=csData;
        if (areaInfo.departyId) {
          this.selecteddepartOption[0] = areaInfo.departyId
          this.blanApply.baseInfo.to_party_id=areaInfo.departyId;
          this.blanApply.reqManInfo.party_id=areaInfo.departyId;
          // if(this.getPartyId){
          //   this.getPartyId(areaInfo.departyId);
          // }
        }

        // let cs=this.$refs['cs'];
        // cs.panel.activePath=[];
        // cs.panel.loadCount=0;
        // cs.panel.lazyLoad();
        // this.areaShow = true;
      }else{
        this.areaShow = true;
      }
    },
  }
}



</script>
<style>
  ._div_botton_border{
    border-bottom: 1px solid #ebedf0;
  }
  ._div_flex{
    display: -webkit-flex; /* Safari */
    display: flex;
    flex-direction: row;
  }
  ._div_width{
    width: 100%;
  }
  ._div_height{
    line-height: 26px;
  }
  ._form_title{
    width: 30%;

  }
  ._form_value{
    width: 70%;

  }
  ._title_div{
    height: 30px;
    line-height: 30px;
    font-size: 14px;

  }
  ._content_div{
    font-size: 14px;
    line-height: 30px;
  }
  .stepDivCss .el-step__description {
    padding-right: 10%;
    margin-top: -5px;
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
    margin-bottom: 20px;
    color:#85888e;
  }
  .stepDivCss .el-step__title {
    font-size: 14px;
    line-height: 38px;
    font-weight: 600;
    color: #303133;
  }
.popup2-box .el-rate__icon {
  font-size: 30px;
  margin-right:0px;
  color: #C0C4CC;
  -webkit-transition: .3s;
  transition: .3s;
}
  .popup2-box .el-rate__text {
    font-size: 14px;
    vertical-align: middle;
    margin-left: 10px;
  }
 .guide_right2_star .el-rate__icon {
    font-size: 30px;
    margin-right:0px;
    color: #C0C4CC;
    -webkit-transition: .3s;
    transition: .3s;
  }

  .dialog_css .el-dialog__body {
    padding: 0;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }
  .dialog_css .el-dialog__header {
    padding: 0px;
  }
  .dialog_css .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 20px;
    font-weight: 900;
  }

  .advice_tab_new22 td {
    padding-bottom: 0px;
  }
  .advice_tab_new22 .el-select{
    margin-left: 0px;
  }
  .advice_tab_new22{margin:0px auto; font-size:14px;}
  .advice_tab_new22 td span{padding-right:10px;}
  .advice_tab_new22 td span img{position:relative; top:2px; margin-right:1px;}
  .advice_tab_new22 textarea{height:102px;width:97%; padding:0px 1.5%;border:1px solid #dbdbdb; padding-top:10px; line-height:26px; font-family:"微软雅黑";}
  .advice_tab_new22 td.enclosuer{}
  .advice_tab_new22 td.enclosuer a{margin-right:20px;}
  /*.advice_tab_new input{*/
    /*width: 250px;*/
  /*}*/
  /*.advice_tab_new select{*/
    /*width: 250px;*/
  /*}*/
  .safe .el-alert__title {
    float: left;
    width: 100%;
    text-align: right;
    font-size: 13px;
    line-height: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/bizApplyQh/ClpApply.vue